<div class="if-checkbox-wrapper">
  <label class="if-checkbox-label">
    <input
      type="checkbox"
      class="if-checkbox"
      [checked]="internalValue"
      [disabled]="isDisabled()"
      (change)="onCheckboxChange($event)"
      (blur)="onBlur()" />
    <span class="if-checkbox-custom" [class.if-error]="variant() === 'error'" [class.if-boundarycondition]="variant() === 'boundarycondition'"></span>
    @if (label()) {
      <span class="if-checkbox-text" [innerHTML]="getSanitizedLabel()"></span>
    }
  </label>
</div>
